/**
 * The two focus treatments every control in this folder draws, written once.
 *
 * Untitled UI draws focus as a 4px `primary-100` halo. Against white that halo
 * is 1.15:1, which is no indicator at all for somebody who needs one, so the
 * shape is kept and the colour is not.
 *
 * BORDERLESS CONTROLS (buttons, tabs, switches, rows) get `shadow-focus`: a 2px
 * gap in the surface colour and then 2px of `--c-border-focus`. The gap is what
 * keeps the ring readable on a primary fill, where a ring touching the button
 * would melt into it. It is the same shadow the global `:focus-visible` rule in
 * index.css draws, stated on the control so a control that sets its own
 * shadow at rest still gets it.
 *
 * BORDERED FIELDS (input, select trigger, textarea) turn the border itself the
 * focus colour, and `shadow-focus-input` keeps the Untitled halo outside it as
 * decoration. The border carries the contrast, the halo carries the look.
 */

/** The ring for anything that has no border of its own. */
export const FOCUS_RING = 'focus-visible:outline-none focus-visible:shadow-focus'

/** A bordered field at rest: one hairline and the extra-small shadow. */
export const FIELD_SHADOW = 'shadow-xs'

/** A bordered field with focus: the edge goes to the focus colour and the halo appears. */
export const FOCUS_FIELD = 'focus:outline-none focus:border-line-focus focus:shadow-focus-input'

/**
 * The same, for a field that says it is wrong. There is no focus token for it,
 * so the halo is spelled out in the error 100 step. The red edge carries the
 * contrast here too.
 */
export const FOCUS_FIELD_INVALID =
  'focus:outline-none focus:border-danger ' +
  'focus:shadow-[0_1px_2px_0_rgb(var(--c-shadow)/0.05),0_0_0_4px_rgb(var(--c-error-100))]'
